import React from 'react';
import RoleBasedRoute from './RoleBasedRoute';

// Component for routes that only coaches can access
export const CoachOnlyRoute = ({ children, showAccessDenied = false }) => {
  return (
    <RoleBasedRoute 
      allowedRoles={['coach']} 
      fallbackPath="/user/coaches"
      showAccessDenied={showAccessDenied}
    >
      {children}
    </RoleBasedRoute>
  );
};

// Component for routes that only clients can access  
export const ClientOnlyRoute = ({ children, showAccessDenied = false }) => {
  return (
    <RoleBasedRoute 
      allowedRoles={['client']} 
      fallbackPath="/coach/dashboard"
      showAccessDenied={showAccessDenied}
    >
      {children}
    </RoleBasedRoute>
  );
};

// Component for routes that only admins can access
export const AdminOnlyRoute = ({ children, showAccessDenied = false }) => {
  return (
    <RoleBasedRoute 
      allowedRoles={['admin']} 
      fallbackPath="/"
      showAccessDenied={showAccessDenied}
    >
      {children}
    </RoleBasedRoute>
  );
};

// Component for routes that both roles can access
export const AuthenticatedRoute = ({ children }) => {
  return (
    <RoleBasedRoute allowedRoles={['coach', 'client', 'admin']}>
      {children}
    </RoleBasedRoute>
  );
};
